import React from "react";
import { Select } from "../../atoms/Select/Select";
import { Label } from "../../atoms/Label/Label";
import { FormError } from "../../atoms/FormError/FormError";
import styles from "./FormFieldSelect.module.css";

// Combinamos las props del Input con las nuestras (label, id, error)
interface FormFieldSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  id: string;
  error?: string;
  options: any;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const FormFieldSelect: React.FC<FormFieldSelectProps> = ({
  label,
  id,
  error,
  options,
  onChange,
  ...inputProps
}) => {
  return (
    <div className="w-full mb-4 flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Select
        id={id}
        name={id}
        isInvalid={!!error}
        options={options}
        onChange={(e) => onChange(e)}
        {...inputProps}
      />
      <FormError>{error}</FormError>
    </div>
  );
};
